<template>
  <div class="d-flex flex-column align-center loginContainer">
    <v-card
      elevation="1"
      outlined
      class="login d-flex flex-column align-center"
      min-width="40%"
    >
      <div class="d-flex flex-column align-center loginImages">
        <v-img
          alt="login Logo"
          class="shrink mr-2 imagenLogin"
          contain
          :src="require('@/assets/img/logoImage.png')"
          transition="scale-transition"
          width="140"
          height="121"
        />
        <v-img
          alt="Login text"
          class="shrink mr-2"
          contain
          :src="require('@/assets/img/logoText.png')"
          transition="scale-transition"
          width="264"
          height="72"
        />
      </div>
      <v-form
        class="formLogin"
        ref="form"
        @submit.prevent="login"
        lazy-validation
      >
        <div class="inputs">
          <v-text-field
            v-model="username"
            :rules="nameRules"
            label="Usuarios"
            required
            class="inputLogin"
            placeholder="Introducir nombre de usuario"
          ></v-text-field>
          <v-text-field
            :append-icon="show3 ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required, rules.min]"
            :type="show3 ? 'text' : 'password'"
            required
            name="password"
            label="Contraseña"
            hint="At least 8 characters"
            v-model="password"
            class="input-group--focused"
            @click:append="show3 = !show3"
            placeholder="Introducir contraseña"
          ></v-text-field>
        </div>
        <div>
          <v-btn
            color="primary"
            class="mr-4"
            type="submit"
            large
            block
          >
            Entrar
          </v-btn>
        </div>
      </v-form>
    </v-card>
    <v-alert
      v-if="!success"
      outlined
      type="error"
      border="left"
    >
      El usuario no existe, inténtalo de nuevo
    </v-alert>
  </div>
</template>

<script>
import { AUTH_REQUEST } from '@/store/actions/auth'
export default {
  name: 'login',

  data () {
    return {
      success: true,
      show1: false,
      show2: true,
      show3: false,
      show4: false,
      username: '',
      password: '',
      nameRules: [
        v => !!v || 'Name is required',
        v => (v && v.length <= 90) || 'Name must be less than 90 characters'
      ],
      rules: {
        required: value => !!value || 'Required.',
        min: v => v.length >= 8 || 'Min 8 characters',
        emailMatch: () => `The email and password you entered don't match`
      }
    }
  },
  methods: {
    login: function () {
      if (!this.validate()) return 0
      const { username, password } = this
      this.$store.dispatch(AUTH_REQUEST, { email: username, password }).then(() => {
        this.$router.push('/')
      })
        .catch(error => {
          this.success = false
          console.log({error})
        })
    },
    validate: function () {
      return this.$refs.form.validate()
    },
    reset: function () {
      this.$refs.form.reset()
    },
    resetValidation: function () {
      this.$refs.form.resetValidation()
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/pages/login.vue